import {
  BaseItem,
  FlatBaseItem,
  FlatTransportationDetails,
  TransportationDetails,
} from 'models/Farmbox/transportation.model';

const transformToHierarchicalStructure = (
  items: FlatBaseItem[],
  TypeClass: new () => BaseItem,
  isFertilizer: boolean
) => {
  if (!items?.length) return [];

  return items.reduce<BaseItem[]>((result, item) => {
    if (item.index) {
      const parent = new TypeClass();
      Object.assign(parent, item);
      if (!isFertilizer) {
        parent.temperatureControl = undefined;
      }
      parent.children = [];
      result.push(parent);
      return result;
    }

    const lastParent = result[result.length - 1];
    if (lastParent?.children) {
      const child = new TypeClass();
      Object.assign(child, item);
      if (!isFertilizer) {
        child.temperatureControl = undefined;
      }
      lastParent.children.push(child);
    }

    return result;
  }, []);
};
const transformHierarchyToFlatStructure = (
  items: BaseItem[],
  isFertilizer: boolean
): FlatBaseItem[] => {
  if (!items?.length) return [];

  const flatItems: FlatBaseItem[] = [];

  items.forEach(item => {
    // Add parent
    const flatParent: FlatBaseItem = {
      id: item.id,
      index: item.index,
      name: item.name,
      province: item.province,
      country: item.country,
      supplierId: item.supplierId,
      temperatureControl: isFertilizer ? item.temperatureControl : undefined,
      isTransportedByAir: item.isTransportedByAir,
    };
    flatItems.push(flatParent);

    // Add children
    if (item.children?.length) {
      item.children.forEach(child => {
        const flatChild: FlatBaseItem = {
          id: child.id,
          index: child.index,
          name: child.name,
          province: child.province,
          country: child.country,
          supplierId: child.supplierId,
          temperatureControl: isFertilizer
            ? child.temperatureControl
            : undefined,
          isTransportedByAir: child.isTransportedByAir,
        };
        flatItems.push(flatChild);
      });
    }
  });

  return flatItems;
};
export const transformHierarchicalToFlatStructure = (
  hierarchicalData: TransportationDetails
): FlatTransportationDetails => {
  const flatData = new FlatTransportationDetails();

  if (hierarchicalData.fertilizers) {
    flatData.fertilizers = transformHierarchyToFlatStructure(
      hierarchicalData.fertilizers,
      true
    );
  }

  if (hierarchicalData.packagings) {
    flatData.packagings = transformHierarchyToFlatStructure(
      hierarchicalData.packagings,
      false
    );
  }

  return flatData;
};
export const transformFlatToHierarchical = (
  flatData: FlatTransportationDetails
): TransportationDetails => {
  const hierarchicalData = new TransportationDetails();

  if (flatData.fertilizers) {
    hierarchicalData.fertilizers = transformToHierarchicalStructure(
      flatData.fertilizers,
      BaseItem,
      true
    );
  }

  if (flatData.packagings) {
    hierarchicalData.packagings = transformToHierarchicalStructure(
      flatData.packagings,
      BaseItem,
      false
    );
  }
  return hierarchicalData;
};
